import { UserRole } from "../../utils/api/endpoints/user/credentials";
import { PaymentStatus } from "../../utils/api/endpoints/paymentsApi";
import useUserCredentials from "../../utils/hooks/user/useUserCredentials";

const PaymentStatusPill = ({ status }: { status: PaymentStatus }) => {
  const { role } = useUserCredentials();
  const pillClassName =
    "text-center rounded-full w-24 py-2 font-medium text-[13px]";

  switch (status) {
    case PaymentStatus.NONE:
      return (
        <p className={"bg-ctb-red-50 text-ctb-red-500 " + pillClassName}>
          None
        </p>
      );
    case PaymentStatus.INITIATED:
      return (
        <p className={"bg-ctb-blue-0 text-ctb-blue-600 " + pillClassName}>
          {role === UserRole.ADMIN ? "Initiated" : "Processing"}
        </p>
      );
    case PaymentStatus.COMPLETE:
      return (
        <p className={"bg-ctb-green-50 text-ctb-green-500 " + pillClassName}>
          Done
        </p>
      );
  }
};

export default PaymentStatusPill;
